<template>
  <div
    v-if="showRenameNotice"
    class="cookie-consent rename-notice"
    role="dialog"
    aria-modal="true"
    :aria-label="m.renameNotice.title"
  >
    <div class="cookie-consent__panel rename-notice__panel">
      <div class="cookie-consent__head">
        <h2 class="cookie-consent__title">{{ m.renameNotice.title }}</h2>
        <div class="cookie-consent__controls">
          <AccessibilityToggle banner />
          <LangSwitch banner :aria-label="m.nav.languageSelection" />
        </div>
      </div>
      <p class="cookie-consent__text rename-notice__text">{{ m.renameNotice.body }}</p>
      <div class="cookie-consent__actions">
        <button
          ref="closeButton"
          type="button"
          class="cookie-consent__btn cookie-consent__btn--primary"
          @click="dismissRenameNotice"
        >
          {{ m.renameNotice.close }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const { messages: m } = useI18n()
const { showRenameNotice, syncRenameNotice, dismissRenameNotice } = useRenameNotice()
const closeButton = ref<HTMLButtonElement | null>(null)

const focusClose = async () => {
  await nextTick()
  if (showRenameNotice.value) closeButton.value?.focus()
}

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape' && showRenameNotice.value) {
    dismissRenameNotice()
  }
}

onMounted(async () => {
  window.addEventListener('keydown', onKeydown)
  await syncRenameNotice()
  await focusClose()
})

watch(showRenameNotice, (open) => {
  if (open) focusClose()
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
})
</script>
